import { render, staticRenderFns } from "./_ACFForm.vue?vue&type=template&id=07dc2a1c&scoped=true&"
import script from "./_ACFForm.vue?vue&type=script&lang=ts&"
export * from "./_ACFForm.vue?vue&type=script&lang=ts&"
import style0 from "./_ACFForm.vue?vue&type=style&index=0&id=07dc2a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc2a1c",
  null
  
)

export default component.exports